module.exports = __webpack_public_path__ + "static/index/img/baikal-1006.33652502.jpg";